import React from "react";
import DialogCore from "../../../saps/components/core/DialogCore";
import { useTranslation } from "react-i18next";
import { Divider, Stack, Typography } from "@mui/material";
import useUser from "../../../../hooks/useUser";

export default function LoginHistory({ loginHistory = [] }) {
  const { t } = useTranslation();
  const { roles } = useUser();
  if (
    !roles.master ||
    loginHistory?.length == 0 ||
    loginHistory == undefined ||
    loginHistory == null
  )
    return null;

  return (
    <DialogCore
      showSubmit={false}
      buttonSize="small"
      buttonVariant="text"
      buttonTitle={`${t("LoginHistory")} (${loginHistory?.length})`}
      title={`${t("UsersLoginHistory")} (${loginHistory?.length})`}
    >
      <Stack spacing={2}>
        {loginHistory?.map((val, index) => (
          <>
            <Stack
              direction={"row"}
              spacing={2}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography>{t("DateAndTime")}</Typography>
              <Typography fontWeight={"bold"} color={"primary"}>
                {val}
              </Typography>
            </Stack>
            {index < loginHistory?.length - 1 && <Divider />}
          </>
        ))}
      </Stack>
    </DialogCore>
  );
}
